module.exports = __webpack_public_path__ + "img/bank_icon2.8a0f0947.png";